<template>
    <div class="">
        <!-- Task Header. -->
        <div class="flex items-center mb-1">
            <div class="w-16">
                <div
                    class="whitespace-pre-line text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    v-text="reference"
                ></div>
            </div>
            <div class="flex-1 ml-0 relative">
                <div
                    class="whitespace-pre-line text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    v-text="name"
                ></div>
                <div class="absolute right-2 top-0 z-20">
                    <div
                        class="inline-block text-xs text-gray-600 m-0 align-top pt-2.5 opacity-25 hover:opacity-100"
                        @click="showFS">
                        <i class="fa fa-upload"></i>
                    </div>
                </div>

            </div>
        </div>
        <!-- Task Items. -->
        <progress-report-item v-for="item in task.items" :key="item.id"
                              :readonly="readonly"
                              :section="section"
                              :progress="progress"
                              :task="task"
                              :fs-modal="fsModal"
                              @changed="$emit('changed')"
                              :item="item"></progress-report-item>
        <div class="py-2"></div>
    </div>
</template>

<script>
import {toCurrency, uuid} from "../../utils";
import ProgressReportItem from "./ProgressReportItem.vue";

export default {
    components: {ProgressReportItem},
    props: {
        progress: Object,
        section: Object,
        task: Object,
        readonly: Boolean,
        fsModal: Object,
    },
    data() {
        return {
            reference: this.task.reference,
            name: this.task.name,
        }
    },
    methods: {
        canEdit() {
            return true
        },
        showFS() {
            this.fsModal.openModal(this.progress.filesystemId, this.task.filesystemPath);
        },
    },
}
</script>
